import React, { useState, useEffect, ReactElement } from 'react';
import './toggle.css';

const sliderDisabled = (isChecked: boolean) => {
  return {
    backgroundColor: isChecked ? '#BBD7B9' : '#EAEAE4',
    boxShadow: 'inset 0 3px 5px rgb(0 0 0 / 28%)',
  };
};

const toggleStyle = (disabled: boolean, isToggle: boolean) => (disabled ? sliderDisabled(isToggle) : {});

interface ToggleProps {
  isChecked: boolean;
  toggleId: string;
  disabled?: boolean;
  showText?: string;
  showBoth?: boolean;
  onChange?: () => void;
}

const Toggle = ({ isChecked, toggleId, disabled, showText, showBoth, ...rest }: ToggleProps): ReactElement => {
  const [isToggle, setToggle] = useState(false);

  useEffect(() => {
    setToggle(isChecked);
  }, [isChecked]);

  const ToggleWithText = () => {
    return showBoth ? (
      <div>
        <div>
          <label className="switch" style={{ float: 'right' }}>
            <input
              id={toggleId}
              type="checkbox"
              // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
              value={isToggle}
              checked={isToggle}
              disabled={disabled}
              {...rest}
            />
            <div className="toggle" style={toggleStyle(disabled, isToggle)}></div>
          </label>
          {showText}
        </div>
      </div>
    ) : (
      <div>{showText}</div>
    );
  };

  return (
    <div>
      {!showText || showText === '' ? (
        <label className="switch">
          <input
            id={toggleId}
            type="checkbox"
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            value={isToggle}
            checked={isToggle}
            disabled={disabled}
            {...rest}
          />
          <div className="toggle" style={toggleStyle(disabled, isToggle)}></div>
        </label>
      ) : (
        ToggleWithText()
      )}
    </div>
  );
};

export default Toggle;
